import * as React from 'react';

import styled from '@emotion/styled';

import { Header } from 'bundles/enterprise-ui';

const Container = styled.div({
  backgroundColor: '#ffffff',
  minHeight: '100vh',
});

const Content = styled.div({
  textAlign: 'center',
  maxWidth: 550,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
});

export const InviteAcceptanceContainer: React.FC<React.HTMLAttributes<HTMLElement>> = ({ children, ...props }) => (
  <Container {...props}>
    <Header />
    <Content>{children}</Content>
  </Container>
);
